import React, { useEffect } from 'react';
import Site from 'components/global/site/Site';
import SiteHeader from 'components/global/site/SiteHeader';
import SiteContent from 'components/global/site/SiteContent';
import SiteFooter from 'components/global/site/SiteFooter';
import SiteHead from 'components/global/site/SiteHead';
import { initializeLogging } from 'utils/logging/InitializeLogging';
import { ServerSidePageProps } from 'types';

interface PageContainerProps {
  pageProps: ServerSidePageProps;
  children: React.ReactNode;
}

function PageContainer(props: PageContainerProps): React.ReactElement {
  const {
    pageProps: {
      header,
      footer,
      meta,
      env,
      title,
      ogImg,
      taxonomyValues,
      activeExperiment,
    } = {},
    children,
  } = props;

  useEffect(() => {
    // Note this will only init on the browser as useEffect does not run serverside
    if (env) {
      initializeLogging('7aadb60ffc0a4b89ad162c4b7c4680d6', env);
    }
  }, []);

  return (
    <>
      <SiteHead
        activeExperiment={activeExperiment}
        meta={{ ...meta, ogImg }}
        availableThemes={env?.availableThemes}
        configEnv={env?.configEnv}
        abTestingClientKey={env?.abTestingClientKey}
        title={title}
        taxonomyValues={taxonomyValues}
      />
      <Site>
        <SiteHeader config={header} meta={meta} />
        <SiteContent>{children}</SiteContent>
        <SiteFooter config={footer} meta={meta} />
      </Site>
    </>
  );
}

export default PageContainer;
